import { Get } from '../fetch';
import { urls } from '../constants';
export async function getVendorPublicInfo() {
  return Get(`${urls.vendor}/public`);
}
;